import { lazy } from 'react'

export const GoingOutVariant1 = lazy(() => import('./GoingOutVariant1'))
